import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { InputNumber } from 'primereact/inputnumber';
import { Divider } from 'primereact/divider';
import Compressor from 'compressorjs';
import axios from 'axios';
import 'primeflex/primeflex.css';
import { API_Root } from '../../globalState';

export const TripFiles = ({ tripId, userId, canEdit = false }) => {
   const [images, setImages] = useState([]);
   const [pendingFile, setPendingFile] = useState(null);
   const [amount, setAmount] = useState(null);
   const [busy, setBusy] = useState(false);
   const fileupload = useRef(null);

   const getImages = (t, u) => {
      if (!t || !u) {
         return;
      }
      var apiUrl = `${API_Root}api/trip/GetTripImagesForUser?tripId=${t}&userId=${u}`;
      axios.get(apiUrl).then((values) => {
         if (values.data != null) {
            setImages(values.data);
         }
      });
   };

   useEffect(() => {
      getImages(tripId, userId);
   }, [tripId, userId]);

   const clearPending = () => {
      setPendingFile(null);
      setAmount(null);
      if (fileupload.current) {
         fileupload.current.clear();
      }
   };

   const onSelectFile = (event) => {
      const file = event.files?.[0];
      if (!file) {
         return;
      }
      setPendingFile(file);
      setAmount(null);
   };

   const saveReceipt = () => {
      if (!pendingFile || amount == null || amount <= 0 || !tripId || !userId) {
         return;
      }
      setBusy(true);
      new Compressor(pendingFile, {
         quality: 0.6,
         maxHeight: 400,
         success(result) {
            const reader = new FileReader();
            reader.onload = () => {
               const dto = {
                  userId: userId,
                  tripId: tripId,
                  fName: pendingFile.name,
                  contents: reader.result,
                  DollarAmount: amount
               };
               axios.post(`${API_Root}api/trip/SaveTripImage`, dto).then(() => {
                  setBusy(false);
                  clearPending();
                  getImages(tripId, userId);
               }).catch(() => setBusy(false));
            };
            reader.readAsDataURL(result);
         },
         error() {
            setBusy(false);
         }
      });
   };

   const deleteImage = (i) => {
      const file = images[i];
      axios.get(`${API_Root}api/trip/DeleteTripImage?id=${file.id}`).then(() => {
         setImages(images.filter((_, idx) => idx !== i));
      });
   };

   const receiptAmount = (f) => {
      const value = f.DollarAmount ?? f.dollarAmount;
      if (value == null || Number(value) <= 0) {
         return null;
      }
      return Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
   };

   const amountValid = amount != null && amount > 0;

   return (
      <div className="mt-4">
         {canEdit ? (
            <>
         <FileUpload
            ref={fileupload}
            mode="basic"
            name="image"
            accept="image/*"
            customUpload
            auto={false}
            onSelect={onSelectFile}
            chooseLabel="Upload receipt"
            maxFileSize={10000000}
         />
         <Divider />
            </>
         ) : null}
         {images?.map((f, i) => {
            const amt = receiptAmount(f);
            return (
               <div key={f.id || i} className="w-full flex flex-column mt-2">
                  <div className="mr-2 relative print-preview-image"
                     style={{ maxWidth: '350px', backgroundImage: "url('" + f.contents.replace(/(\r\n|\n|\r)/gm, "") + "')" }}>
                     {canEdit ? (
                     <i className="pi pi-times-circle absolute right-0 top-0 mt-1 mr-1 text-red-600 cursor-pointer text-lg" onClick={() => deleteImage(i)}></i>
                     ) : null}
                  </div>
                  {amt && <div className="font-bold mt-1">{amt} reimbursable</div>}
               </div>
            );
         })}
         <Dialog
            header="Reimbursable amount"
            visible={!!pendingFile}
            className="sm:w-11 md:w-6 lg:w-4"
            closable={!busy}
            onHide={() => { if (!busy) clearPending(); }}
            footer={(
               <div className="flex justify-content-end gap-2">
                  <Button label="Cancel" className="p-button-text" onClick={() => clearPending()} disabled={busy} />
                  <Button
                     label="Save receipt"
                     onClick={() => saveReceipt()}
                     loading={busy}
                     disabled={busy || !amountValid}
                  />
               </div>
            )}>
            <p className="mt-0 mb-3">Enter the reimbursable amount from this receipt. This is required to save the file.</p>
            <label htmlFor="receipt-amount" className="block mb-2 font-bold">Dollar amount</label>
            <InputNumber
               id="receipt-amount"
               className="w-full"
               inputClassName="w-full"
               mode="currency"
               currency="USD"
               locale="en-US"
               min={0.01}
               minFractionDigits={2}
               value={amount}
               onValueChange={(e) => setAmount(e.value)}
            />
         </Dialog>
      </div>
   );
};
